import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';
import axios from 'axios';
import type SignaturePadElement from './signature_pad_element';

@registerElement('onboarding-npi-validator')
export default class OnboardingNPIValidatorElement extends ImpulseElement {
  @property() src: string;

  @target() actions: HTMLElement;

  @target() npiContainer: HTMLElement;
  @target() npiField: HTMLInputElement;
  @target() noNPIMessage: HTMLElement;

  @target() signatureContainer: HTMLElement;
  @target() signaturePad: SignaturePadElement;

  @target() submitButton: HTMLInputElement;
  @target() resetButton: HTMLButtonElement;

  // States
  @target() loading: HTMLElement;
  @target() success: HTMLElement;
  @target() error: HTMLElement;

  noNPINumber() {
    this.npiContainer.hidden = true;
    this.submitButton.disabled = false;
    this.noNPIMessage.hidden = false;
    this.npiField.value = '';
  }

  async validateNPINumber() {
    if (!this.src || !this.npiField.value) return;
    this.loading.hidden = false;
    this.actions.hidden = true;

    try {
      await axios.post(this.src, { npi_number: this.npiField.value });
      this.success.hidden = false;
      this.signatureContainer.hidden = false;
      this.signaturePad.calculateDimensions();
      this.signaturePad.required = true;
      this.error.hidden = true;
    } catch {
      this.success.hidden = true;
      this.signatureContainer.hidden = true;
      this.error.hidden = false;
      this.signaturePad.required = false;
      this.npiField.value = '';
    } finally {
      this.loading.hidden = true;
      this.submitButton.disabled = false;
      this.npiField.readOnly = true;
      this.resetButton.hidden = false;
    }
  }

  reset() {
    // Start the signature over, which also discards an upload and brings the typing field back.
    // Otherwise validating again marks the hidden, empty typing field required and the browser
    // silently refuses to submit. Cleared before `required` is set below, since discarding an
    // upload restores the requirement the pad had when the upload was shown.
    this.signaturePad.clear();
    this.success.hidden = true;
    this.signatureContainer.hidden = true;
    this.signaturePad.required = false;
    this.actions.hidden = false;
    this.npiContainer.hidden = false;
    this.npiField.readOnly = false;
    this.submitButton.disabled = true;
    this.resetButton.hidden = true;
    this.error.hidden = true;
    this.noNPIMessage.hidden = true;
    this.npiField.value = '';
    this.npiField.focus();
  }
}
